module.exports = __webpack_public_path__ + "static/media/rohithsajja.a73eecaf.png";